<template>
  <div class="footer-container">
    <!-- <div class="yhzximg" @click="openDraw = UserConsulShow = true">
      <img :src="yhzximg" alt="">
    </div> -->
    <div class="backtop">
      <el-backtop :bottom="100">
        <div
          style="
            height: 100%;
            width: 100%;
            background-color: var(--el-bg-color-overlay);
            box-shadow: var(--el-box-shadow-lighter);
            text-align: center;
            color: #1989fa;
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            padding: 8px;
          "
          @mouseenter="isHovered2 = true"
          @mouseleave="isHovered2 = false"
        >
          <img
            style="width: 24px; height: 24px; margin-bottom: 4px"
            :src="isHovered2 ? hdb01 : hdb02"
            alt="返回顶部"
          />
          <p style="margin: 0; font-size: 12px; color: #999999">回顶部</p>
        </div>
      </el-backtop>
    </div>
    <div
      class="yhzximg"
      @click="openDraw = UserConsulShow = true"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
    >
      <img :src="isHovered ? yhzximg01 : yhzximg" alt="" />
    </div>
    <div
      class="UserConsul"
      v-show="UserConsulShow"
      ref="draggableForm"
      @mousedown="startDrag"
    >
      <div class="userTitle">
        <div><p>请您留言</p></div>
        <div @click="Closedraw" class="userTitleClose">
          <el-icon><Close /></el-icon>
        </div>
      </div>
      <div class="userText">
        <p>感谢您的关注，请填写一下您的信息，我们会尽快和您联系。</p>
        <p>联系方式：18701020128</p>
        <el-form :model="form" :rules="rules" label-width="auto">
          <el-form-item prop="message">
            <el-input
              v-model="form.message"
              type="textarea"
              :rows="4"
              resize="none"
              placeholder="请在此输入留言内容，我们会尽快与您联系。 (必填)"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item prop="name">
            <el-input v-model="form.name" placeholder="姓名" />
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="form.phone" placeholder="电话（必填）" />
          </el-form-item>
          <el-form-item prop="company">
            <el-input v-model="form.company" placeholder="公司名称（必填）" />
          </el-form-item>
          <el-form-item prop="questionType">
            <p style="font-size: 14px; margin-top: 10px">咨询问题类型</p>
            <el-select
              v-model="form.questionType"
              placeholder="请选择问题类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item style="">
            <el-button type="primary" @click="submitForm">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 底部内容 -->
    <div class="footer-content">
      <!-- 第一列：公司 Logo 和名称 -->
      <!-- <div class="footer-column1">
          <div class="company-info">
            <img src="https://via.placeholder.com/100x40" alt="公司 Logo" class="company-logo" />
            <div class="company-name">忆知科技有限公司</div>
          </div>
        </div> -->

      <!-- 第二列：解决方案 -->
            <div class="footer-column2">
        <div class="column-title">导航</div>
        <ul class="column-list">
          <li
            v-for="(item, index) in solutions"
            :key="index"
          >
            <RouterLink :to="{ path: item.path }">{{ item.name }}</RouterLink>
          </li>
        </ul>
      </div>

      <!-- 第三列：关于忆知 -->
      <div class="footer-column3">
        <div class="column-title">解决方案</div>
        <ul class="column-list">
          <li
            v-for="(item, index) in aboutYizhi"
            :key="index"
            @click="aboutNewPage(index)"
          >
            <a :href="item.link" target="_blank">{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-column3">
        <div class="column-title">版权申明</div>
        <ul class="column-list">
          <li
            v-for="(item, index) in banquanYizhi"
            :key="index"
            @click="banquanNewPage(item.name)"
          >
            <a :href="item.link" target="_blank">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <!-- 第四列：联系我们 -->
      <div class="footer-column4">
        <div class="column-title">联系我们</div>
        <ul class="column-list2">
          <li
            v-for="(item, index) in contactUs"
            :key="index"
            @click="UserConsultation(item.name)"
          >
            <a :href="item.link" target="_blank">{{ item.name }}</a>
          </li>
        </ul>
      </div>

      <!-- 第五列：公众号和微信二维码 -->
      <div class="footer-column5">
        <div class="column-title">关注亿知</div>
        <div class="qr-codes">
          <div>
            <img :src="coderimage" alt="公众号二维码" />
          </div>
          <div class="qr-item">
            <div
              style="
                text-align: left;
                color: rgba(255, 255, 255, 0.75);
                font-size: 12px;
              "
            >
              关注亿知公众号
            </div>
            <div
              style="
                text-align: left;
                color: rgba(255, 255, 255, 0.75);
                font-size: 12px;
              "
            >
              随时随地了解知识库产品动态及服务
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部版权信息 -->
    <div class="footer-link">
      © 2025 陕西亿知信息科技有限公司.
      <a href="https://beian.miit.gov.cn" target="_blank"
        >备案号：陕ICP备2024041505号-3</a
      >
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, nextTick, onMounted } from "vue";
import footerimg from "@/assets/image/coderimg.png";
import yhzximg from "@/assets/headerimage/activeKefu02.png";
import yhzximg01 from "@/assets/headerimage/activeKefu01.png";
import hdb01 from "@/assets/headerimage/hdb01.png";
import hdb02 from "@/assets/headerimage/hdb02.png";
import { useRouter, useRoute } from "vue-router";
import { Close, CaretTop } from "@element-plus/icons-vue";

import { ElMessage } from "element-plus"; // 添加 ElMessage 的导入

const coderimage = ref(footerimg);
const router = useRouter();
const route = useRoute();
const textarea = ref("");
const UserConsulShow = ref(false);
const isHovered = ref(false);
const isHovered2 = ref(false);
const value = ref("");
// 表单数据
const form = reactive({
  message: "",
  name: "",
  phone: "",
  company: "",
  questionType: "",
});
// 解决方案列表
const solutions = ref([
  { name: "区域销售", path: "/agency" },
  { name: "资源合作", path: "/cooperation" },
  { name: "动态要闻", path: "/hydtinfolist" },
]);

// 关于忆知列表
const aboutYizhi = ref([
  { name: "知识库建设方案" },
  { name: "全流程AI数字出版平台" },
  { name: "出版社本地模型部署" },
  // { name: '加入我们', link: 'https://example.com/join' },
]);

// 联系我们列表
const contactUs = ref([
  { name: "咨询电话: 18701020128" },
  { name: "咨询邮箱: hs891213@163.com" },
  { name: "用户咨询" },
]);

const banquanYizhi = ref([
  { name: "版权说明" },
  // { name: "版权归属" },
  // { name: "版权限制" },
  // { name: "版权处理" },
  // { name: "合作申明" },
]);
const aboutNewPage = (index) => {
       localStorage.setItem("lastSelectTime", Date.now().toString());
  router.push({
    name: "solution",
    query: { index },
  });
};
const banquanNewPage = (name) => {
  router.push({
    name: "copyright",
    // query: { name },
  });
};
const NavNewPage = (name) => {
  if (name === "首页") {
    router.push({
      name: "Home",
    });
  } else if (name === "知识产品") {
    router.push({
      name: "knowledge",
    });
  } else if (name === "代理机构") {
    router.push({
      name: "agency",
    });
  }
};

const UserConsultation = (name) => {
  if (name === "用户咨询") {
    UserConsulShow.value = true;
  }
};

const Closedraw = () => {
  form.message = "";
  form.name = "";
  form.phone = "";
  form.company = "";
  form.questionType = "";
  UserConsulShow.value = false;
};

const formRef = ref(null);
const draggableForm = ref(null);
let isDragging = false;
let startX, startY, x, y;

const startDrag = (e) => {
  isDragging = true;
  const element = draggableForm.value;
  startX = e.pageX - element.offsetLeft;
  startY = e.pageY - element.offsetTop;
  document.addEventListener("mousemove", drag);
  document.addEventListener("mouseup", stopDrag);
};

const drag = (e) => {
  if (!isDragging) return;
  const element = draggableForm.value;
  x = e.pageX - startX;
  y = e.pageY - startY;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const formWidth = element.offsetWidth;
  const formHeight = element.offsetHeight;

  if (x < 0) {
    x = 0;
  } else if (x > windowWidth - formWidth) {
    x = windowWidth - formWidth;
  }

  if (y < 0) {
    y = 0;
  } else if (y > windowHeight - formHeight) {
    y = windowHeight - formHeight;
  }

  element.style.left = x + "px";
  element.style.top = y + "px";
};

const stopDrag = () => {
  isDragging = false;
  document.removeEventListener("mousemove", drag);
  document.removeEventListener("mouseup", stopDrag);
};

// form.message = '默认留言内容';
// form.name = '';
// form.phone = '';
// form.company = '';
// form.questionType = 'option1';

// 下拉选项
const options = [
  { value: "option1", label: "产品咨询" },
  { value: "option2", label: "技术支持" },
  { value: "option3", label: "商务合作" },
  { value: "option4", label: "其他问题" },
];

// 验证规则
const rules = reactive({
  message: [{ required: true, message: "请输入留言内容", trigger: "blur" }],
  phone: [
    { required: true, message: "请输入电话", trigger: "blur" },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: "请输入正确的手机号码",
      trigger: "blur",
    },
  ],
  company: [{ required: true, message: "请输入公司名称", trigger: "blur" }],
});

// 提交表单
const submitForm = async () => {
  try {
    await nextTick();
    console.log("formRef.value:", formRef.value); // 添加这行日志
    if (!formRef.value) {
      console.error("表单引用为空，请检查表单是否正确渲染。");
      return;
    }
    await formRef.value.validate();
    // 验证通过，执行提交逻辑
    console.log("表单数据:", form);
    // 这里可以添加API调用
    ElMessage.success("提交成功！");
  } catch (error) {
    console.log("表单验证失败:", error);
    ElMessage.error("请填写完整信息");
  }
};

onMounted(() => {
});
</script>

<style scoped>
.footer-container {
  padding: 40px 0px 20px;
  /* border-top: 1px solid #e6e6e6; */
  width: 100%;
  /* background-image: url(@/assets/image/footer.png); */
  background: #222629;
}

.footer-content {
  width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  flex-wrap: wrap;
  margin-bottom: 60px;
}

.footer-column {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
}

.company-info {
  display: flex;
  align-items: center;
  gap: 10px;
}

.company-logo {
  width: 100px;
  height: auto;
}

.company-name {
  font-size: 18px;
  font-weight: bold;
}

.column-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.column-list {
  list-style: none;
  padding: 0;
  margin-top: 20px;
  cursor: pointer;
}
.column-list2 {
  list-style: none;
  padding: 0;
  margin-top: 20px;
  cursor: pointer;
}

.column-list li {
  margin-bottom: 8px;
}

.column-list a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  font-family: PingFangSC, PingFang SC;
}
.column-list2 li {
  margin-bottom: 8px;
}

.column-list2 a {
  text-decoration: none;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 400;
  font-size: 12px;
  text-align: left;
  font-style: normal;
  font-family: PingFangSC, PingFang SC;
}
.column-list a:hover {
  color: #409eff;
}

.qr-codes {
  display: flex;
  gap: 20px;
  margin-top: 20px;
}

.qr-item {
  text-align: left;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.qr-code {
  width: 100px;
  height: 100px;
  margin-bottom: 8px;
}

.footer-copyright {
  text-align: center;
  margin-top: 20px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.75);

  padding-top: 20px;
}
.footer-link {
  color: rgba(255, 255, 255, 0.75); /* 蔚蓝色（DodgerBlue） */
  text-align: center;
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  height: 50px;
  line-height: 50px;
}
.footer-link a {
  width: 100%;
  text-decoration: none; /* 去掉下划线 */
  color: rgba(255, 255, 255, 0.75); /* 蔚蓝色（DodgerBlue） */
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif; /* 可选：设置字体 */
  font-weight: 400;
  font-size: 12px;
  font-style: normal;
}
.UserConsul {
  position: fixed;
  width: 320px;
  height: 512px;
  background: #fff;
  right: 128px;
  bottom: 12px;
  border-radius: 6px;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.2);
  cursor: move;
  z-index: 99;
}

.userTitle {
  width: 100%;
  height: 54px;
  background: #2c77ff;
  line-height: 54px;
  color: #fff;
  padding-left: 16px;
  font-size: 19px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  display: flex;
  justify-content: space-between;
}
.userTitleClose {
  padding-right: 15px;
  cursor: pointer;
}

.userText {
  width: 100%;
  height: calc(512px - 54px);
  padding: 15px;
  box-sizing: border-box;
}

.userText p {
  color: #303133;
  font-weight: 400;
  white-space: pre-line;
  text-align: justify;
  margin-bottom: 10px;
  font-size: 15px;
}

.el-form-item {
  margin-bottom: 15px;
}
:deep(.el-form-item__content) {
  line-height: 0 !important;
  color: #909399;
  /* margin-top: 10px; */
}
:deep(.el-select__wrapper) {
  margin-top: 5px;
}

:deep(.el-form-item:last-child .el-form-item__content) {
  display: flex;
  justify-content: flex-end;
}
.yhzximg {
  width: 62px;
  height: 59px;
  position: fixed;
  right: 41px;
  bottom: 169px;
  z-index: 999;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.yhzximg img {
  width: 24px;
  height: 24px;
  z-index: 999;
}
.el-backtop {
  cursor: pointer;
  display: flex;
  font-size: 20px;
  height: 59px;
  justify-content: center;
  position: fixed;
  width: 62px;
  height: 59px;
  z-index: 5;
}

/* .getuserdraw{
  width: 140px;
  height: 90px;
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(0,0,0,0.12);
  border-radius: 6px;
} */


</style>
